import { IChangeRequest } from "@wot/typings";
import { API_URL } from "../utils/constants";
import xhr from "../utils/fetch";
import { LPlan } from "../interfaces/Plan";

export type IPlanStatus = "active" | "pending" | "cancelled" | 'completed';
export interface PUpdatePlanStatus {
  _id: string,
  data: {
    status: IPlanStatus
  }
}

const getById = async (id: string) => {
  return await fetch(`${API_URL}/a/plan/${id}`, {
    method: "GET",
    headers: {
      "Content-type": "application/json",
    },
    credentials: "include",
  }).then((res) => res.json())
    .then((data) => data)
    .catch(err => console.log(err))
}

const getPlans = async (
  currentPage: number,
  resultsPerPage: number,
  filters: any,
  sortBy: any
): Promise<{ count: number; results: LPlan[] }> => {
  const res = await xhr({
    url: `/a/plans`,
    method: 'GET',
    params: {
      resultsPerPage: resultsPerPage.toString(),
      page: currentPage.toString(),
      ...filters,
      ...sortBy
    }
  });
  if (res.status === 'OK') {
    return res.data;
  } else {
    throw Error(res.message);
  }
};


const getChangeRequests = async (
  currentPage: number,
  resultsPerPage: number,
  filters: any,
  sortBy: any
) => {
  const res = await xhr({
    url: `/a/plans/change-requests`,
    method: 'GET',
    params: {
      resultsPerPage: resultsPerPage.toString(),
      page: currentPage.toString(),
      ...filters,
      ...sortBy
    }
  });
  if (res.status === 'OK') {
    return res.data;
  } else {
    throw Error(res.message);
  }
}


const handleChangeRequest = async (data: { _id: string, status: string }) => {
  return await fetch(`${API_URL}/a/plan/${data._id}/change-request`, {
    method: "POST",
    headers: {
      "Content-type": "application/json"
    },
    credentials: 'include',
    body: JSON.stringify(data)
  })
    .then((res) => res.json())
    .then((res) => res)
    .catch(err => console.log(err));
}

const updatePlanStatus = async (data: PUpdatePlanStatus) => {
  if (data.data.status === "cancelled") {
    return await fetch(`${API_URL}/a/plans/${data._id}/cancel`, {
      method: "PUT",
      headers: {
        "Content-type": "application/json"
      },
      credentials: 'include',
      body: JSON.stringify(data)
    })
      .then((res) => res.json())
      .then((res) => res)
      .catch(err => console.log(err));
  } else {
    return await fetch(`${API_URL}/a/plans/${data._id}/status`, {
      method: "PUT",
      headers: {
        "Content-type": "application/json"
      },
      credentials: 'include',
      body: JSON.stringify({ status: data.data.status })
    })
      .then((res) => res.json())
      .then((res) => res)
      .catch(err => console.log(err));
  }
}

const updatePlan = async (id: string, data: any) => {
  console.log(JSON.stringify(data))
  return await fetch(`${API_URL}/a/plan/${id}`, {
    method: "PUT",
    credentials: 'include',
    headers: {
      "Content-type": "application/json"
    },
    body: JSON.stringify(data)
  })
    .then((res) => res.json())
    .then((res) => res)
    .catch(err => console.log(err));
}

const updatePlanPaymentStatus = async (_id: string, status: string) => {
  return await xhr({
    url: `/a/plans/${_id}/payment-status`,
    method: "PUT",
    body: {
      status
    }
  }).then((res) => res.data)
    .catch((err) => { throw err })
}

const plansApi = {
  getById,
  getPlans,
  getChangeRequests,
  handleChangeRequest,
  updatePlanStatus,
  updatePlanPaymentStatus,
  updatePlan
}

export default plansApi